import { Button } from "@warp-ds/react/components/button";
import { Trans } from "@lingui/react/macro";

export type CreateItemButtonProps = {
	itemCreationUrl: string;
	apiPathname: string;
	shouldCreateItem: boolean;
	secondary?: boolean;
};

export function CreateItemButton(props: CreateItemButtonProps) {
	const {
		itemCreationUrl,
		apiPathname,
		shouldCreateItem,
		secondary = false,
	} = props;

	return (
		<Button
			primary={!secondary}
			secondary={secondary}
			fullWidth
			className="mt-32 md:w-auto"
			href={!shouldCreateItem ? itemCreationUrl : undefined}
			onClick={async () => {
				let redirectUrl = itemCreationUrl;
				if (shouldCreateItem) {
					const response = await fetch(`${apiPathname}/api/items/create`, {
						method: "POST",
					});
					if (response.ok) {
						const item = await response.json();
						redirectUrl = `/recommerce/create/${item.id}`;
					} else {
						console.error("Failed to create item");
					}
				}

				window.location.href = redirectUrl;
			}}
		>
			<Trans id="button.createItem">Post an ad</Trans>
		</Button>
	);
}
